import { render } from "./Newsflash.vue?vue&type=template&id=adf7e0d6"
import script from "./Newsflash.vue?vue&type=script&lang=ts"
export * from "./Newsflash.vue?vue&type=script&lang=ts"

import "./Newsflash.vue?vue&type=style&index=0&id=adf7e0d6&lang=scss"
script.render = render

export default script